.PageHeader {
    padding-left: 30px;
}